import { CancellationsProvider } from "../../context";
import ContentCancellationsPage from "./content";

const CancellationsPage = () => (
  <CancellationsProvider>
    <ContentCancellationsPage />
  </CancellationsProvider>
);

export default CancellationsPage;
